<template>
  <div class="info-row-container">
    <div class="icon-container">
      <i :class="icon"></i>
    </div>
    <div class="label-container">{{ label }}:</div>
    <div class="value-container">{{ formattedValue }}</div>
  </div>
</template>

<script>
export default {
  name: 'FormInfoRow',
  props: {
    icon: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: true
    },
    value: {
      type: [String, Number, Date],
      default: ''
    }
  },
  computed: {
    formattedValue() {
      if (!this.value) return '';
      
      // 日付形式の文字列をYYYY/MM/DD形式に変換
      if (typeof this.value === 'string' && this.value.includes('T')) {
        try {
          const date = new Date(this.value);
          return new Intl.DateTimeFormat('ja-JP', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit'
          }).format(date).replace(/\//g, '/');
        } catch (e) {
          return this.value;
        }
      }
      
      return this.value;
    }
  }
}
</script>

<style scoped>
.info-row-container {
  display: flex;
  align-items: center;
  padding: 8px 0;
}

.icon-container {
  width: 30px;
  display: flex;
  justify-content: center;
  color: #195983;
  font-size: 18px;
}

.label-container {
  min-width: 100px;
  font-weight: 700;
}

.separator {
  margin: 0 10px;
}

.value-container {
  flex: 1;
}
</style>
